import { Maybe, nothing } from 'maybeasy';
import { currentUserStore } from '../../../../CurrentUserStore';
import { SearchParameters } from '../../../../ListFilter/Types';
import { when } from '@execonline-inc/maybe-adapter';
import { StringOption } from '../../../Options/Types';

interface DefaultOrgFilter {
  searchParameters: SearchParameters;
  selectedOrganization: Maybe<StringOption>;
}

const nonExoFilter: DefaultOrgFilter = {
  searchParameters: [],
  selectedOrganization: nothing(),
};

export const defaultOrgFilter = () =>
  when(currentUserStore.exoOrg, {})
    .andThen(() => currentUserStore.organizationOption)
    .map((org) => ({
      searchParameters: [{ key: 'organization_id', value: org.value }],
    }))
    .getOrElseValue(nonExoFilter);
